module.exports = __webpack_public_path__ + "img/doc.ce7feecc.svg";